import React, { useState, useEffect, useRef, useCallback } from "react";
import { useAuth } from "../AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import JsBarcode from "jsbarcode";
import KakaoMap from "./KakaoMap";

import EXIF from 'exif-js';
import piexif from "piexifjs";
import Pica from 'pica';
//import { BlobServiceClient } from '@azure/storage-blob';
import AddLog from "./AddLog"; // ✅ 로그 저장 함수 가져오기
import "../styles/EnshrineAdd.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const EnshrineAdd = () => {
    const { user, setUser } = useAuth();
    const navigate = useNavigate();
    const barcodeRef = useRef(null);
    const [progress, setProgress] = useState(0);
    const [isLoading, setIsLoading] = useState(false); // 로딩 상태 추가

    //const [plist, setPlist] = useState([]);
    //const [glist, setGlist] = useState([]);
    const location = useLocation();
    const [PListData, setPListData] = useState(location.state?.PList || null);
    const [GListData, setGListData] = useState(location.state?.GList || null);

    const hasRun = useRef(false);
    const hasRun2 = useRef(false);
    
    const [formData, setFormData] = useState({
        enshrinecode: "",
        partnercode: "",
        governmentcode: "",

        enshrinetype: "",
        enshrinedate: "",
        deceasedname: "",
        deceasedbplace: "",
        deceasedbdate: "",
        deceaseddplace: "",
        deceasedddate: "",
        bereavedids: "",
        bereavedinfo: "",
        deceasedmemo: "",
        
        cpictureurl: null,
        epictureurl: null,
        ppictureurl: null,

        mpicture01url: null,
        mpicture02url: null,
        mpicture03url: null,
        mpicture04url: null,
        mpicture05url: null,
        mpicture06url: null,
        mpicture07url: null,
        mpicture08url: null,
        mpicture09url: null,
        mpicture10url: null,

        mvideourl: null,

        cemeterylatitude: null,
        cemeterylongitude: null,
        enshrinelatitude: null,
        enshrinelongitude: null,
        address1: "",
        address2: "",

        cimgURL: "",
        eimgURL: "",
        pimgURL: "",
        mimg01URL: "",
        mimg02URL: "",
        mimg03URL: "",
        mimg04URL: "",
        mimg05URL: "",
        mimg06URL: "",
        mimg07URL: "",
        mimg08URL: "",
        mimg09URL: "",
        mimg10URL: "",
        videoURL: "",

        jesaType: "",
    });

    // 각 파일 입력 필드의 개별 useRef 추가
    const fileInputRefs = {
        ppictureurl: useRef(null),
        cpictureurl: useRef(null),
        epictureurl: useRef(null),

        mpicture01url: useRef(null),
        mpicture02url: useRef(null),
        mpicture03url: useRef(null),
        mpicture04url: useRef(null),
        mpicture05url: useRef(null),
        mpicture06url: useRef(null),
        mpicture07url: useRef(null),
        mpicture08url: useRef(null),
        mpicture09url: useRef(null),
        mpicture10url: useRef(null),

        mvideourl: useRef(null),
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []); // 페이지 로드 시 실행

    useEffect(() => {
        if (hasRun.current) return; // 이미 실행되었으면 종료

        hasRun.current = true; // 첫 실행 후 플래그 설정

        const now = new Date();
        const formattedCode = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}${String(now.getHours()).padStart(2, "0")}${String(now.getMinutes()).padStart(2, "0")}${String(now.getSeconds()).padStart(2, "0")}${String(now.getMilliseconds()).padStart(3, "0")}`;
        //setEnshrineCode(formattedCode);
        setFormData(prevFormData => ({
            ...prevFormData,
            enshrinecode: formattedCode,
        }));

        if (barcodeRef.current) {
            JsBarcode(barcodeRef.current, formattedCode, {
                format: "CODE128",  // 바코드 포맷
                width: 3,           // 바코드 선의 너비 (기본값보다 크게 설정하면 가로로 길어짐)
                height: 60,        // 바코드의 세로 높이
                displayValue: true // 바코드 하단에 숫자 값을 표시할지 여부 (필요시 true로 설정)
            });
        }

        //if (user.userType === "S") {
        //    getPartnerCode();
        //    getGovernmentCode();
        //}
        
    }, []); // 최초 렌더링 시 1회 실행

    useEffect(() => {
        if (hasRun2.current) return; // 이미 실행되었으면 종료

        hasRun2.current = true; // 첫 실행 후 플래그 설정

        if (user) {
            // user 객체가 업데이트 된 후에 formData를 업데이트
            setFormData(prevFormData => ({
                ...prevFormData,
                partnercode: user.partnerCode || '',  // user.partnerCode가 있을 때만 할당
                governmentcode: user.governmentCode || '',  // user.governmentCode가 있을 때만 할당
            }));
        }
        //console.log("몇번실행될지????");
    }, [user]); // user 객체가 변경될 때마다 실행

    /*
    // 파트너 코드 리스트 가져오기
    const getPartnerCode = async () => {

        try {
            const response = await fetch(`${API_BASE_URL}/api/Partner/get-list`);
            const data = await response.json();

            if (response.ok) {
                setPlist(data.plist);
                //console.log(data.plist);
            } else {
                alert(data.message || "조회 실패");
            }

        } catch (error) {
            alert("파트너 리스트 조회 중 오류가 발생했습니다.");
        }
    };

    // 파트너 코드 리스트 가져오기
    const getGovernmentCode = async () => {

        try {
            const response = await fetch(`${API_BASE_URL}/api/Government/get-list`);
            const data = await response.json();

            if (response.ok) {
                setGlist(data.glist);
                //console.log(data.glist);
            } else {
                alert(data.message || "조회 실패");
            }

        } catch (error) {
            alert("관공서 리스트 조회 중 오류가 발생했습니다.");
        }
    };
    */

    // Azure Storage 연결
    /*
    const blobServiceClient = BlobServiceClient.fromConnectionString('DefaultEndpointsProtocol=https;AccountName=bitdam;AccountKey=9bPIqGIIuefkfTE+pp2hKpzeXEogg/7VdKpZrljbjC7ur+GyPLpk6v13sl/GWrBQ9u8wD3x7qI7++AStlIdBHQ==;EndpointSuffix=core.windows.net');
    const containerClient = blobServiceClient.getContainerClient('bitdam');

    // 파일 업로드 함수
    const uploadFileToBlob = async (fileBlob, fileName) => {
        const blockBlobClient = containerClient.getBlockBlobClient(fileName);
        await blockBlobClient.uploadBrowserData(fileBlob);
        return blockBlobClient.url;  // 업로드된 파일의 URL 반환
    };
    */
   /*
    const resizeImage = (file, maxSize = 1920) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            const reader = new FileReader();

            reader.onload = () => {
                img.onload = () => {
                    const pica = new Pica();
                    const canvas = document.createElement("canvas");

                    const scale = Math.max(img.width, img.height) / maxSize;
                    const width = img.width / scale;
                    const height = img.height / scale;

                    canvas.width = width;
                    canvas.height = height;

                    pica.resize(img, canvas)
                        .then(() => {
                            canvas.toBlob((blob) => {
                                resolve(blob);
                            }, file.type);
                        })
                        .catch(reject);
                };
                img.src = reader.result;
            };

            reader.readAsDataURL(file);
        });
    };
    */


    const resizeImageWithExif = (file, maxSize = 1920) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = async (event) => {
                const originalDataUrl = event.target.result;
                const img = new Image();
                img.src = originalDataUrl;

                img.onload = async () => {
                    let exifObj = {};
                    let orientation = 1;
                    let isJpeg = file.type === "image/jpeg";

                    // JPEG인 경우에만 EXIF 데이터 로드
                    if (isJpeg) {
                        try {
                            // EXIF 데이터 로드
                            const exifData = piexif.load(originalDataUrl);

                            // EXIF 데이터 구조 확인
                            //console.log("EXIF 데이터:", exifData);

                            // EXIF 데이터에 Orientation이 있을 경우, 해당 값 추출
                            if (exifData["0th"] && exifData["0th"][piexif.TagValues.ExifIFD.Orientation]) {
                                orientation = exifData["0th"][piexif.TagValues.ExifIFD.Orientation];
                            }
                            //console.log("Orientation 값:", orientation);
                        } catch (e) {
                            //console.warn("EXIF 데이터 없음:", e);
                        }
                    }

                    const pica = new Pica();
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");

                    let width = img.width;
                    let height = img.height;

                    // 이미지 크기 조정 (비율 유지)
                    const scale = Math.max(width, height) / maxSize;
                    width = Math.round(width / scale);
                    height = Math.round(height / scale);

                    // 회전이 필요한 경우 캔버스 크기 설정
                    if (orientation > 4) {
                        canvas.width = height;
                        canvas.height = width;
                    } else {
                        canvas.width = width;
                        canvas.height = height;
                    }

                    // 캔버스에 이미지 그리기
                    ctx.save(); // 현재 상태 저장

                    switch (orientation) {
                        case 2: // 좌우 반전
                            ctx.translate(canvas.width, 0);
                            ctx.scale(-1, 1);
                            break;
                        case 3: // 180도 회전
                            ctx.translate(canvas.width, canvas.height);
                            ctx.rotate(Math.PI);
                            break;
                        case 4: // 상하 반전
                            ctx.translate(0, canvas.height);
                            ctx.scale(1, -1);
                            break;
                        case 5: // 90도 회전 & 좌우 반전
                            ctx.translate(canvas.width, 0);
                            ctx.rotate(Math.PI / 2);
                            ctx.scale(1, -1);
                            break;
                        case 6: // 90도 회전 (세로 사진이 가로로 누워 있던 문제 해결)
                            ctx.translate(canvas.width, 0);
                            ctx.rotate(Math.PI / 2);
                            break;
                        case 7: // 270도 회전 & 좌우 반전
                            ctx.translate(0, canvas.height);
                            ctx.rotate(-Math.PI / 2);
                            ctx.scale(1, -1);
                            break;
                        case 8: // 270도 회전
                            ctx.translate(0, canvas.height);
                            ctx.rotate(-Math.PI / 2);
                            break;
                        default:
                            break;
                    }

                    // 회전한 방향에 맞게 이미지 배치
                    if (orientation > 4) {
                        ctx.drawImage(img, 0, 0, height, width);
                    } else {
                        ctx.drawImage(img, 0, 0, width, height);
                    }

                    ctx.restore(); // 변환 상태 복원

                    try {
                        await pica.resize(canvas, canvas);
                        let resizedDataUrl = canvas.toDataURL(file.type, 0.7);


                        if (isJpeg) {
                            // 원본 EXIF 데이터를 유지하여 삽입
                            resizedDataUrl = piexif.insert(piexif.dump(exifObj), resizedDataUrl);
                        }

                        // DataURL을 Blob으로 변환
                        const blob = dataURLtoBlob(resizedDataUrl, file.type);
                        resolve(blob);
                    } catch (error) {
                        reject(error);
                    }
                };
            };
        });
    };

    // DataURL -> Blob 변환 함수
    const dataURLtoBlob = (dataURL, mimeType) => {
        const byteString = atob(dataURL.split(",")[1]);
        const mimeString = dataURL.split(",")[0].split(":")[1].split(";")[0];

        const arrayBuffer = new ArrayBuffer(byteString.length);
        const intArray = new Uint8Array(arrayBuffer);

        for (let i = 0; i < byteString.length; i++) {
            intArray[i] = byteString.charCodeAt(i);
        }

        return new Blob([arrayBuffer], { type: mimeType || mimeString });
    };

   /*
    const resizeImageWithExif = (file, maxSize = 1920) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = async (event) => {
                const originalDataUrl = event.target.result;
                const img = new Image();
                img.src = originalDataUrl;

                img.onload = async () => {
                    // 원본 이미지의 EXIF 데이터 추출
                    let exifObj = {};
                    try {
                        const exifData = piexif.load(originalDataUrl);
                        exifObj = exifData;
                    } catch (e) {
                        console.warn("EXIF 데이터 없음:", e);
                    }

                    // 이미지 리사이징
                    const pica = new Pica();
                    const canvas = document.createElement("canvas");

                    const scale = Math.max(img.width, img.height) / maxSize;
                    const width = img.width / scale;
                    const height = img.height / scale;

                    canvas.width = width;
                    canvas.height = height;

                    try {
                        await pica.resize(img, canvas);
                        const resizedDataUrl = canvas.toDataURL(file.type, 1.0); // 품질 100%

                        // 원본 EXIF 데이터를 리사이즈된 이미지에 다시 추가
                        const exifInsertedDataUrl = piexif.insert(piexif.dump(exifObj), resizedDataUrl);

                        // DataURL을 Blob으로 변환
                        const blob = dataURLtoBlob(exifInsertedDataUrl, file.type);
                        resolve(blob);
                    } catch (error) {
                        reject(error);
                    }
                };
            };
        });
    };

    // DataURL을 Blob으로 변환하는 함수
    const dataURLtoBlob = (dataURL, mimeType) => {
        const byteString = atob(dataURL.split(',')[1]);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const uint8Array = new Uint8Array(arrayBuffer);

        for (let i = 0; i < byteString.length; i++) {
            uint8Array[i] = byteString.charCodeAt(i);
        }

        return new Blob([arrayBuffer], { type: mimeType });
    };
    */
    const generateFileName = (enshrineCode, index, fileExtension) => {
        const now = new Date();
        const dateString = now.toISOString().replace(/[-T:.]/g, '').slice(0, 14);  // 'YYYYMMDDHHMMSS' 형식
        const suffix = String.fromCharCode(65 + index); // A, B, C, ...

        if (suffix === "A") { formData.cimgURL = `${dateString}.${fileExtension}`; }
        else if (suffix === "B") { formData.eimgURL = `${dateString}.${fileExtension}`; }
        else if (suffix === "C") { formData.pimgURL = `${dateString}.${fileExtension}`; }
        else if (suffix === "D") { formData.mimg01URL = `${dateString}.${fileExtension}`; }
        else if (suffix === "E") { formData.mimg02URL = `${dateString}.${fileExtension}`; }
        else if (suffix === "F") { formData.mimg03URL = `${dateString}.${fileExtension}`; }
        else if (suffix === "G") { formData.mimg04URL = `${dateString}.${fileExtension}`; }
        else if (suffix === "H") { formData.mimg05URL = `${dateString}.${fileExtension}`; }
        else if (suffix === "I") { formData.mimg06URL = `${dateString}.${fileExtension}`; }
        else if (suffix === "J") { formData.mimg07URL = `${dateString}.${fileExtension}`; }
        else if (suffix === "K") { formData.mimg08URL = `${dateString}.${fileExtension}`; }
        else if (suffix === "L") { formData.mimg09URL = `${dateString}.${fileExtension}`; }
        else if (suffix === "M") { formData.mimg10URL = `${dateString}.${fileExtension}`; }
        else if (suffix === "N") { formData.videoURL = `${dateString}.${fileExtension}`; }

        return `${enshrineCode}/${suffix}/${dateString}.${fileExtension}`;
    };


    /*
    useEffect(() => {
        if (mapRef.current) {
            // 지도 초기화 후 크기 조정
            mapRef.current.leafletElement.invalidateSize();
        }
    }, [formData.cemeterylatitude, formData.cemeterylongitude]);

    // formData의 위도, 경도가 있을 때 자동으로 주소 가져오기
    useEffect(() => {
        if (formData.cemeterylatitude && formData.cemeterylongitude) {
            getAddressFromCoordinates(formData.cemeterylatitude, formData.cemeterylongitude)
                .then((addr) => setAddress(addr));
        }
    }, [formData.cemeterylatitude, formData.cemeterylongitude]);

    // formData의 위도, 경도가 있을 때 자동으로 주소 가져오기
    useEffect(() => {
        if (formData.enshrinelatitude && formData.enshrinelongitude) {
            getAddressFromCoordinates(formData.enshrinelatitude, formData.enshrinelongitude)
                .then((addr) => setAddress2(addr));
        }
    }, [formData.enshrinelatitude, formData.enshrinelongitude]);
    */

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => {
            let updatedFormData = { ...prev, [name]: value };

            // 파트너 코드 변경 시, 관련된 관공서 코드 자동 설정
            if (name === "partnercode") {
                const selectedPartner = PListData.find(p => p.partnerCode === value);
                updatedFormData.governmentcode = selectedPartner ? selectedPartner.governmentCode || "" : "";
            }

            return updatedFormData;
        });

        // textarea 높이 자동 조절
        //e.target.style.height = "auto";  // 높이 초기화
        e.target.style.height = e.target.scrollHeight + "px"; // 컨텐츠 높이에 맞게 조절
    };

    function isRecentlyTaken(file) {
        return new Promise((resolve) => {
            EXIF.getData(file, function () {
                const dateTimeOriginal = EXIF.getTag(this, "DateTimeOriginal");

                if (!dateTimeOriginal) {
                    // EXIF 데이터가 없으면 `file.lastModified` 비교
                    const now = new Date().getTime();
                    resolve(now - file.lastModified < 5000);
                    return;
                }

                // EXIF에서 가져온 날짜를 파싱하여 비교
                const dateParts = dateTimeOriginal.split(" ");
                const dateStr = dateParts[0].replace(/:/g, "-") + " " + dateParts[1];
                const takenTime = new Date(dateStr).getTime();
                const now = new Date().getTime();

                resolve(now - takenTime < 5000); // 5초 이내 촬영된 경우 true
            });
        });
    }

    const requestLocation = (name, updatedData) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const latitude = parseFloat(position.coords.latitude.toFixed(7));
                    const longitude = parseFloat(position.coords.longitude.toFixed(7));

                    if (name === "cpictureurl") {
                        updatedData.cemeterylatitude = latitude;
                        updatedData.cemeterylongitude = longitude;
                    } else if (name === "epictureurl") {
                        updatedData.enshrinelatitude = latitude;
                        updatedData.enshrinelongitude = longitude;
                    }

                    setFormData((prevData) => ({
                        ...prevData,
                        ...updatedData,
                    }));
                },
                (error) => {
                    console.error("GPS 정보를 가져올 수 없습니다.", error);
                }
            );
        } else {
            alert("이 브라우저에서는 위치 정보를 지원하지 않습니다.");
        }
    };

    const handleFileChange = (event) => {
        const { name, files } = event.target;

        if (files.length === 0) {
            handleRemoveImage(name);
            return;
        }

        else if (files.length > 0) {
            const file = files[0];
            const imageUrl = URL.createObjectURL(file);
            const maxSize = name === "mvideourl" ? 200 * 1024 * 1024 : 20 * 1024 * 1024; // 동영상: 200MB, 사진: 20MB

            if (file.size > maxSize) {
                alert(`${name === "mvideourl" ? "동영상" : "사진"} 파일 크기가 너무 큽니다! 최대 허용 크기: ${name === "mvideourl" ? "200MB" : "20MB"}`);
                event.target.value = ""; // 파일 입력 초기화 (선택한 파일 취소)
                return;
            }
            // 기본적으로 formData 업데이트
            let updatedData = {
                [name]: { file, preview: imageUrl, fileName: file.name },
            };

            // 특정 이미지(cpictureurl, epictureurl)일 경우 GPS 데이터 초기화
            if (name === "cpictureurl") {
                updatedData.cemeterylatitude = null;
                updatedData.cemeterylongitude = null;
                formData.address1 = "";
                setLatitudeInput("");
                setLongitudeInput("");
            } else if (name === "epictureurl") {
                updatedData.enshrinelatitude = null;
                updatedData.enshrinelongitude = null;
                formData.address2 = "";
                setLatitudeInput2("");
                setLongitudeInput2("");
            }
            // 상태 업데이트 (기본 파일 데이터 먼저 저장)
            setFormData((prevData) => ({
                ...prevData,
                ...updatedData,
            }));

            // 특정 이미지(cpictureurl, epictureurl)일 경우 EXIF 데이터에서 GPS 정보 추출
            if (name === "cpictureurl" || name === "epictureurl") {                
                EXIF.getData(file, function () {
                    const lat = EXIF.getTag(this, "GPSLatitude");
                    const lon = EXIF.getTag(this, "GPSLongitude");
                    const latRef = EXIF.getTag(this, "GPSLatitudeRef");
                    const lonRef = EXIF.getTag(this, "GPSLongitudeRef");

                    let latitude = "";
                    let longitude = "";

                    if (lat && lon) {
                        latitude = convertDMSToDD(lat[0], lat[1], lat[2], latRef);
                        longitude = convertDMSToDD(lon[0], lon[1], lon[2], lonRef);

                        // 소수점 7자리까지 제한
                        latitude = latitude ? parseFloat(latitude.toFixed(7)) : "";
                        longitude = longitude ? parseFloat(longitude.toFixed(7)) : "";

                        // 특정 이미지 타입에 대해 위도/경도 값을 설정 (소수점 7자리 제한)
                        if (name === "cpictureurl") {
                            updatedData.cemeterylatitude = latitude;
                            updatedData.cemeterylongitude = longitude;
                        } else if (name === "epictureurl") {
                            updatedData.enshrinelatitude = latitude;
                            updatedData.enshrinelongitude = longitude;
                        }
                    }
                    else {
                        // 🚀 사진을 최근 촬영했는지 확인하고, GPS 정보 추가
                        isRecentlyTaken(file).then((recent) => {
                            if (recent) {
                                // 🎯 사용자 액션이 있어야 네이버 앱에서 정상 작동 가능
                                const confirmLocation = window.confirm("현재 위치를 가져올까요?");
                                if (confirmLocation) {
                                    requestLocation(name, updatedData);
                                }

                                /*
                                if (navigator.geolocation) {
                                    navigator.geolocation.getCurrentPosition(
                                        (position) => {
                                            latitude = parseFloat(position.coords.latitude.toFixed(7));
                                            longitude = parseFloat(position.coords.longitude.toFixed(7));

                                            if (name === "cpictureurl") {
                                                updatedData.cemeterylatitude = latitude;
                                                updatedData.cemeterylongitude = longitude;
                                            } else if (name === "epictureurl") {
                                                updatedData.enshrinelatitude = latitude;
                                                updatedData.enshrinelongitude = longitude;
                                            }
                                            // 상태 업데이트
                                            setFormData((prevData) => ({
                                                ...prevData,
                                                ...updatedData,
                                            }));
                                            //console.error("현재 GPS 정보");
                                        },
                                        (error) => {
                                            console.error("GPS 정보를 가져올 수 없습니다.", error);
                                        }
                                    );
                                }
                                */
                            }
                        });
                    }

                    // 상태 업데이트
                    setFormData((prevData) => ({
                        ...prevData,
                        ...updatedData,
                    }));
                });
            } else {
                // 위도/경도 처리가 필요 없는 경우 바로 상태 업데이트
                setFormData((prevData) => ({
                    ...prevData,
                    ...updatedData,
                }));
            }
        }
    };

    // DMS(도, 분, 초) -> Decimal Degrees 변환 함수
    const convertDMSToDD = (degrees, minutes, seconds, direction) => {
        let dd = degrees + minutes / 60 + seconds / 3600;
        if (direction === "S" || direction === "W") {
            dd = dd * -1; // 남쪽, 서쪽이면 음수로 변환
        }
        return dd;
    };

    const handleRemoveImage = (name) => {
        setFormData((prevData) => {
            const updatedData = {
                ...prevData,
                [name]: null,
            };

            // 특정 이미지가 삭제될 때 위도/경도 값 초기화
            if (name === "cpictureurl") {
                updatedData.cemeterylatitude = null;
                updatedData.cemeterylongitude = null;
                formData.address1 = "";
                setLatitudeInput("");
                setLongitudeInput("");
            } else if (name === "epictureurl") {
                updatedData.enshrinelatitude = null;
                updatedData.enshrinelongitude = null;
                formData.address2 = "";
                setLatitudeInput2("");
                setLongitudeInput2("");
            }

            
            return updatedData;
        });

        // 개별 파일 입력 필드 초기화
        if (fileInputRefs[name]?.current) {
            fileInputRefs[name].current.value = "";
        }
    };

    // 기존 formData를 복사하여 변경하는 함수
    const updateBereavedIds = () => {
        let value = formData.bereavedids.trim(); // 앞뒤 공백 제거

        if (value === "") {
            value = ""; // 빈 문자열이면 그대로 ""
        } else {
            value = value.replace(/\s+/g, ""); // 모든 공백 제거            
            value = value.replace(/,+/g, ","); // 연속된 콤마를 하나로 변환
        }

        setFormData((prevData) => ({
            ...prevData,
            bereavedids: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (formData.enshrinetype === "") {
            alert("봉안유형을 선택해주세요.");

            // 경고창 확인 후 봉안유형 필드로 포커스 이동
            setTimeout(() => {
                document.getElementsByName("enshrinetype")[0].focus();
            }, 0);

            return;
        }
        else if (formData.enshrinetype === "A") {
            if (formData.enshrinedate === "") {
                alert("봉안일자를 입력해주세요.");

                setTimeout(() => {
                    document.getElementsByName("enshrinedate")[0].focus();
                }, 0);

                return;
            }
            else if (formData.cpictureurl === "" || formData.cpictureurl === null) {
                alert("묘지사진을 등록해주세요.");

                setTimeout(() => {
                    document.getElementsByName("cpictureurl")[0].focus();
                }, 0);

                return;
            }            
            else if (formData.cemeterylatitude === null || formData.cemeterylongitude === null) {
                alert("묘지사진의 위치정보를 등록해주세요.");

                setTimeout(() => {
                    document.getElementsByName("location")[0].focus();
                }, 0);

                return;
            }            
        }
        else if (formData.enshrinetype === "B") {
            if (formData.cpictureurl === "" || formData.cpictureurl === null) {
                alert("묘지사진을 등록해주세요.");

                setTimeout(() => {
                    document.getElementsByName("cpictureurl")[0].focus();
                }, 0);

                return;
            }
            else if (formData.cemeterylatitude === null || formData.cemeterylongitude === null) {
                alert("묘지사진의 위치정보를 등록해주세요.");

                setTimeout(() => {
                    document.getElementsByName("location")[0].focus();
                }, 0);

                return;
            }            
        }
        else if (formData.enshrinetype === "C") {
            if (formData.enshrinedate === "") {
                alert("봉안일자를 입력해주세요.");
                setTimeout(() => {
                    document.getElementsByName("enshrinedate")[0].focus();
                }, 0);
                return;
            }
            else if (formData.deceasedname === "") {
                alert("고인성명을 입력해주세요.");
                setTimeout(() => {
                    document.getElementsByName("deceasedname")[0].focus();
                }, 0);
                return;
            }
            else if (formData.deceasedddate === "") {
                alert("사망일을 입력해주세요.");
                setTimeout(() => {
                    document.getElementsByName("deceasedddate")[0].focus();
                }, 0);
                return;
            }
            else if (formData.epictureurl === "" || formData.epictureurl === null) {
                alert("봉안사진을 등록해주세요.");
                setTimeout(() => {
                    document.getElementsByName("epictureurl")[0].focus();
                }, 0);
                return;
            }
            
        }
        else if (formData.enshrinetype === "D" || formData.enshrinetype === "E") {
            if (formData.enshrinedate === "") {
                alert("봉안일자를 입력해주세요.");
                setTimeout(() => {
                    document.getElementsByName("enshrinedate")[0].focus();
                }, 0);
                return;
            }
            else if (formData.deceasedname === "") {
                alert("고인성명을 입력해주세요.");
                setTimeout(() => {
                    document.getElementsByName("deceasedname")[0].focus();
                }, 0);
                return;
            }
            else if (formData.deceasedddate === "") {
                alert("사망일을 입력해주세요.");
                setTimeout(() => {
                    document.getElementsByName("deceasedddate")[0].focus();
                }, 0);
                return;
            }
            if (formData.cpictureurl === "" || formData.cpictureurl === null) {
                alert("묘지사진을 등록해주세요.");
                setTimeout(() => {
                    document.getElementsByName("cpictureurl")[0].focus();
                }, 0);
                return;
            }
            else if (formData.cemeterylatitude === null || formData.cemeterylongitude === null) {
                alert("묘지사진의 위치정보를 등록해주세요.");
                setTimeout(() => {
                    document.getElementsByName("location")[0].focus();
                }, 0);
                return;
            }  
        }
        ////////////////////////////////////////
        if (formData.enshrinetype === "A") {            
            formData.deceasedname = "";
            formData.deceasedbplace = "";
            formData.deceasedbdate = "";
            formData.deceaseddplace = "";
            formData.deceasedddate = "";
            formData.bereavedids = "";
            formData.bereavedinfo = "";     
            
            formData.ppictureurl = null;           
        }
        else if (formData.enshrinetype === "B") {
            formData.enshrinedate = "";
            formData.deceasedname = "";
            formData.deceasedbplace = "";
            formData.deceasedbdate = "";
            formData.deceaseddplace = "";
            formData.deceasedddate = "";
            formData.bereavedids = "";
            formData.bereavedinfo = "";

            formData.ppictureurl = null;
            formData.epictureurl = null;
            formData.enshrinelatitude = null;
            formData.enshrinelongitude = null;
            formData.address2 = "";
        }
        else if (formData.enshrinetype === "C") {
            formData.cpictureurl = null;
            formData.cemeterylatitude = null;
            formData.cemeterylongitude = null;
            formData.address1 = "";
            updateBereavedIds();
        }
        else if (formData.enshrinetype === "D" ) {
            updateBereavedIds();
        }
        else if (formData.enshrinetype === "E") {
            formData.epictureurl = null;
            formData.enshrinelatitude = null;
            formData.enshrinelongitude = null;
            formData.address2 = "";
            updateBereavedIds();
        }

        formData.cimgURL = "";
        formData.eimgURL = "";
        formData.pimgURL = "";
        formData.mimg01URL = "";
        formData.mimg02URL = "";
        formData.mimg03URL = "";
        formData.mimg04URL = "";
        formData.mimg05URL = "";
        formData.mimg06URL = "";
        formData.mimg07URL = "";
        formData.mimg08URL = "";
        formData.mimg09URL = "";
        formData.mimg10URL = "";
        formData.videoURL = "";

        const enshrineCode = formData.enshrinecode;
        const fileInputs = [            
            fileInputRefs.cpictureurl,
            fileInputRefs.epictureurl,
            fileInputRefs.ppictureurl,

            fileInputRefs.mpicture01url,
            fileInputRefs.mpicture02url,
            fileInputRefs.mpicture03url,
            fileInputRefs.mpicture04url,
            fileInputRefs.mpicture05url,
            fileInputRefs.mpicture06url,
            fileInputRefs.mpicture07url,
            fileInputRefs.mpicture08url,
            fileInputRefs.mpicture09url,
            fileInputRefs.mpicture10url,      

            fileInputRefs.mvideourl,
        ];

        let ErrMsg = "";
        setIsLoading(true); // 파일 업로드 시작 전 로딩 애니메이션 활성화

        for (let i = 0; i < fileInputs.length; i++) {

            const fileInput = fileInputs[i];

            // fileInput이 useRef로 감싸져 있을 경우 fileInput.current를 사용
            if (!fileInput.current) {
                console.log(`fileInput[${i}]가 Hidden되어 건너뜁니다.`);
                continue;
            }

            const file = fileInput.current.files[0];

            if (file) {
                try {
                    // 리사이즈
                    let resizedFile = file; // 기본적으로 원본 파일을 사용
                    let thumbnailFile = null; // 썸네일 파일

                    if (fileInput.current.name !== "mvideourl") {
                        // 이미지 크기 확인 후, 리사이즈 여부 결정
                        const img = new Image();
                        img.src = URL.createObjectURL(file);

                        await new Promise((resolve) => {
                            img.onload = async () => {
                                if (img.width > 1920 || img.height > 1920) {
                                    const blob = await resizeImageWithExif(file);
                                    resizedFile = new File([blob], file.name, { type: file.type }); // Blob → File 변환
                                }

                                // 썸네일 생성 (긴 쪽 200px)
                                const thumbBlob = await resizeImageWithExif(file, 200);

                                // 올바른 파일명 생성 (확장자 앞에 `_T` 추가)
                                const fileExtension = file.name.split('.').pop(); // 확장자 추출
                                const fileNameWithoutExt = file.name.replace(`.${fileExtension}`, ""); // 확장자 제외 파일명
                                const thumbFileName = `${fileNameWithoutExt}_T.${fileExtension}`; // `_T` 추가된 파일명

                                thumbnailFile = new File([thumbBlob], thumbFileName, { type: file.type });

                                resolve();
                            };
                        });
                    }

                    // 파일 확장자 추출
                    const fileExtension = file.name.split('.').pop();

                    // 파일명 생성
                    const fileName = generateFileName(enshrineCode, i, fileExtension);
                    const thumbFileName = fileName.replace(`.${fileExtension}`, `_T.${fileExtension}`); // 썸네일 파일명 생성

                    // Azure에 업로드
                    setProgress(0);
                    const uploadedUrl = await uploadToAzure(resizedFile, fileName, setProgress);
                    
                    // Azure에 업로드 (썸네일 이미지)
                    if (thumbnailFile) {
                        const uploadedThumbUrl = await uploadToAzure(thumbnailFile, thumbFileName, setProgress);
                        //console.log(`Thumbnail ${thumbFileName} uploaded successfully`);
                    }
                                        
                    //console.log(`${fileInput.current.name} ${uploadedUrl} Image ${i + 1} uploaded `);
                    console.log(`${fileInput.current.name} Image ${i + 1} uploaded `);

                    if (!uploadedUrl) {
                        //console.log("***uploadedUrl:", uploadedUrl);
                        if (fileInput.current.name === "cpictureurl") {
                            formData.cimgURL = "";
                            //setFormData(prevFormData => ({ ...prevFormData, cimgURL: "", }));     // /A/    묘지
                        }
                        else if (fileInput.current.name === "epictureurl") {
                            formData.eimgURL = "";
                            //setFormData(prevFormData => ({ ...prevFormData, eimgURL: "", }));     // /B/    봉안
                        }
                        else if (fileInput.current.name === "ppictureurl") {
                            formData.pimgURL = "";
                            //setFormData(prevFormData => ({ ...prevFormData, pimgURL: "", }));     // /C/    영정 
                        }

                        else if (fileInput.current.name === "mpicture01url") {
                            formData.mimg01URL = "";
                            //setFormData(prevFormData => ({ ...prevFormData, mimg01URL: "", }));     // 
                        }
                        else if (fileInput.current.name === "mpicture02url") {
                            formData.mimg02URL = "";
                            //setFormData(prevFormData => ({ ...prevFormData, mimg02URL: "", }));     // 
                        }
                        else if (fileInput.current.name === "mpicture03url") {
                            formData.mimg03URL = "";
                            //setFormData(prevFormData => ({ ...prevFormData, mimg03URL: "", }));     // 
                        }
                        else if (fileInput.current.name === "mpicture04url") {
                            formData.mimg04URL = "";
                            //setFormData(prevFormData => ({ ...prevFormData, mimg04URL: "", }));     // 
                        }
                        else if (fileInput.current.name === "mpicture05url") {
                            formData.mimg05URL = "";
                            //setFormData(prevFormData => ({ ...prevFormData, mimg05URL: "", }));     // 
                        }
                        else if (fileInput.current.name === "mpicture06url") {
                            formData.mimg06URL = "";
                            //setFormData(prevFormData => ({ ...prevFormData, mimg06URL: "", }));     // 
                        }
                        else if (fileInput.current.name === "mpicture07url") {
                            formData.mimg07URL = "";
                            //setFormData(prevFormData => ({ ...prevFormData, mimg07URL: "", }));     // 
                        }
                        else if (fileInput.current.name === "mpicture08url") {
                            formData.mimg08URL = "";
                            //setFormData(prevFormData => ({ ...prevFormData, mimg08URL: "", }));     // 
                        }
                        else if (fileInput.current.name === "mpicture09url") {
                            formData.mimg09URL = "";
                            //setFormData(prevFormData => ({ ...prevFormData, mimg09URL: "", }));     // 
                        }
                        else if (fileInput.current.name === "mpicture10url") {
                            formData.mimg10URL = "";
                            //setFormData(prevFormData => ({ ...prevFormData, mimg10URL: "", }));     // 
                        }
                        else if (fileInput.current.name === "mvideourl") {
                            //console.log("mvideourl 저장실패");
                            formData.videoURL = "";
                            //setFormData(prevFormData => ({ ...prevFormData, videoURL: "", }));     // 
                        }

                        //await uploadError(formData.enshrinecode, fileInput.current.name);

                        //console.log("videoURL이 변경됨:", formData.videoURL);
                        ErrMsg = "일부 오류가 발생되어 저장되지 못한 미디어가 있습니다. 다시 확인 해주세요!"
                    }






                } catch (error) {
                    console.error(`Error uploading image ${i + 1}:`, error);
                }
            }
        }

        // SQL 서버에 URL 저장       
        try {            
            const response = await fetch(`${API_BASE_URL}/api/Enshrine/add-enshrine`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();
            setIsLoading(false); // 요청 완료 후 로딩 해제

            if (response.ok) {

                await AddLog(user.userId, "", formData.enshrinecode, "3-1");

                setIsLoading(false); // 요청 완료 후 로딩 해제
                alert("새 봉안 등록이 완료되었습니다.");

                if (ErrMsg !== "") {
                    alert(ErrMsg);
                }

                navigate(-1); // 이전 페이지로 이동
            } else {
                setIsLoading(false); // 요청 완료 후 로딩 해제
                alert("새 봉안 등록에 실패했습니다: " + data.message);
                //console.log("응답 상태 코드:", response.status);
                //console.log("서버 응답 데이터:", data);
            }

        } catch (error) {
            setIsLoading(false); // 오류 발생 시 로딩 해제
            //console.error("오류:", error);
            alert("봉안 등록 중 오류가 발생했습니다.");
        }
        setIsLoading(false); // 요청 완료 후 로딩 해제
        //console.log("Form Submitted:", formData);
    };




    async function uploadToAzure(file, fileName, onProgress) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("fileName", fileName);

        try {
            const response = await axios.post(`${API_BASE_URL}/api/upload/image`, formData, {
                
                timeout: 600000, // 10분
                headers: {
                    "Accept": "application/json", // JSON 응답 받기
                },
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    onProgress(percentCompleted);
                }
            });

            return response.data.fileUrl;
        } catch (error) {
            console.error("업로드 오류:", error);
            if (error.response) {
                console.error("응답 데이터:", error.response.data);
            }
        }
    }

    /*
    async function uploadToAzure(resizedFile, fileName) {
        const formData = new FormData();
        formData.append("file", resizedFile);
        formData.append("fileName", fileName); // 파일명 추가

        // 타임아웃을 위한 AbortController 생성
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 3000000); // 300초(5분) 후에 타임아웃 발생


        try {

            const response = await fetch(`${API_BASE_URL}/api/upload/image`, {
                method: "POST",
                body: formData,
                signal: controller.signal, // 타임아웃 설정을 위한 signal
            });
            
            clearTimeout(timeoutId); // 타임아웃 클리어

            if (!response.ok) {
                throw new Error("파일 업로드 실패");
            }

            const data = await response.json();
            console.log("업로드 성공:", data);
            return data.fileUrl; // 업로드된 파일의 URL 반환
        } catch (error) {
            console.error("업로드 오류:", error);
        }
    }
    */

    const LoadingSpinner = () => (
        <div className="loading-overlay">
            <div className="spinner"></div>
        </div>
    );


    // 주소 검색 버튼 클릭 시 카카오 주소 검색 API 실행
    const handleSearchAddress = (inputType) => {
        new window.daum.Postcode({
            oncomplete: function (data) {
                let fullAddress = data.address; // 사용자가 선택한 주소

                // 좌표 변환 (주소 → 위도, 경도)
                const geocoder = new window.kakao.maps.services.Geocoder();
                geocoder.addressSearch(fullAddress, function (result, status) {
                    if (status === window.kakao.maps.services.Status.OK) {
                        const latitude = parseFloat(result[0].y).toFixed(7);  // 소수점 이하 7자리로 반올림
                        const longitude = parseFloat(result[0].x).toFixed(7); // 소수점 이하 7자리로 반올림
                        setFormData(prev => ({
                            ...prev,
                            // 📌 cpictureurl이면 cemetery 좌표, epictureurl이면 enshrine 좌표 저장
                            ...(inputType === "cpictureurl"
                                ? { cemeterylatitude: latitude, cemeterylongitude: longitude }
                                : { enshrinelatitude: latitude, enshrinelongitude: longitude }),
                            address: fullAddress, // 주소 저장
                        }));
                    } else {
                        alert("주소의 좌표를 찾을 수 없습니다.");
                    }
                });
            },
        }).open();
    };

    const handleAddressChange1 = useCallback((newAddress) => {
        setFormData((prev) => ({
            ...prev,
            address1: newAddress,
        }));
    }, []);
    const handleAddressChange2 = useCallback((newAddress) => {
        setFormData((prev) => ({
            ...prev,
            address2: newAddress,
        }));
    }, []);

    const [latitudeInput, setLatitudeInput] = useState("");
    const [longitudeInput, setLongitudeInput] = useState("");   
    const handleCoordinateSearch = () => {
        const lat = parseFloat(latitudeInput).toFixed(7);
        const lng = parseFloat(longitudeInput).toFixed(7);

        // 위도와 경도의 유효 범위 검사
        if (isNaN(lat) || lat < -90 || lat > 90) {
            alert("올바른 위도를 입력하세요!");
            setLatitudeInput(''); // 위도 입력 필드 값 삭제
            return;
        }

        if (isNaN(lng) || lng < -180 || lng > 180) {
            alert("올바른 경도를 입력하세요!");
            setLongitudeInput(''); // 경도 입력 필드 값 삭제
            return;
        }

        // 위도, 경도가 유효한 경우에만 폼 데이터 업데이트
        setFormData(prev => ({
            ...prev,
            cemeterylatitude: lat,
            cemeterylongitude: lng
        }));
    };

    const [latitudeInput2, setLatitudeInput2] = useState("");
    const [longitudeInput2, setLongitudeInput2] = useState("");
    const handleCoordinateSearch2 = () => {
        const lat = parseFloat(latitudeInput2).toFixed(7);
        const lng = parseFloat(longitudeInput2).toFixed(7);

        // 위도와 경도의 유효 범위 검사
        if (isNaN(lat) || lat < -90 || lat > 90) {
            alert("올바른 위도를 입력하세요!");
            setLatitudeInput2(''); // 위도 입력 필드 값 삭제
            return;
        }

        if (isNaN(lng) || lng < -180 || lng > 180) {
            alert("올바른 경도를 입력하세요!");
            setLongitudeInput2(''); // 경도 입력 필드 값 삭제
            return;
        }

        // 위도, 경도가 유효한 경우에만 폼 데이터 업데이트
        setFormData(prev => ({
            ...prev,
            enshrinelatitude: lat,
            enshrinelongitude: lng
        }));
    };


    const handlePrint = () => {
        if (!barcodeRef.current) return;

        const svgElement = barcodeRef.current;
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const svgData = new XMLSerializer().serializeToString(svgElement);
        const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
        const url = URL.createObjectURL(svgBlob);

        const img = new Image();
        img.onload = () => {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            URL.revokeObjectURL(url);

            const printWindow = window.open("", "_blank");
            if (printWindow) {
                printWindow.document.write(`
                <html>
                    <head>
                        <title>바코드 출력</title>
                        <style>
                            body { text-align: center; margin: 20px; }
                            img { width: 300px; height: auto; }
                        </style>
                    </head>
                    <body>
                        <img src="${canvas.toDataURL()}" />
                        <script>
                            window.onload = function() {
                                window.print();
                                window.close();
                            };
                        </script>
                    </body>
                </html>
            `);
                printWindow.document.close();
            }
            else {
                alert("팝업 차단이 활성화되어 있습니다. 설정을 확인해주세요.");
            }
        };
        img.src = url;
    };



    return (
        <div className="enshrine-wrapper">
            
            <button className="back-button" onClick={() => navigate(-1)}>
                <i className="fa fa-arrow-left" aria-hidden="true"> BACK</i>
            </button>
            <h1 className="title">새 봉안 추가</h1>

            <hr className="title-line" />

            <div className="enshrine-add-container">
                <form onSubmit={handleSubmit} className="form-container">
                    <div className="input-group">
                        <label>고유번호</label>
                        <input
                            className="disabled-input"
                            type="text"
                            name="enshrinecode"
                            value={formData.enshrinecode} // formData에서 값 가져오기        
                            //onChange={handleChange}   
                            readOnly                                                     
                        />  
                        {/* 공백 추가 */}
                        <div style={{ margin: "2px 0" }}></div>                        
                        {/*<svg ref={barcodeRef}></svg>*/}
                        {(user.userType !== "U") && (
                            <svg ref={barcodeRef} onClick={handlePrint} style={{ cursor: "pointer" }}></svg>
                        )}
                    </div>                    
                    
                    {(user.userType === "S") && (
                        <>
                            <div className="input-group">
                                {/* 공백 추가 */}
                                <div style={{ margin: "8px 0" }}></div>
                                <label>파트너코드</label>

                                <select name="partnercode"  value={formData.partnercode} onChange={handleChange}>
                                    <option value="">파트너를 선택하세요</option> {/* 기본값 */}
                                    {PListData.map((partner) => (
                                        <option key={partner.snum} value={partner.partnerCode}>
                                            {partner.snum}, {partner.partnerCode} : {partner.partnerName}
                                        </option>
                                    ))}
                                </select>
                                


                                {/* 공백 추가 */}
                                <div style={{ margin: "8px 0" }}></div>
                                <label>관공서코드</label>


                                <select name="governmentcode" disabled={true} value={formData.governmentcode} onChange={handleChange}>
                                    <option value="">관공서를 선택하세요</option> {/* 기본값 */}
                                    {GListData.map((government) => (
                                        <option key={government.snum} value={government.governmentCode}>
                                            {government.snum}, {government.governmentCode} : {government.governmentName}
                                        </option>
                                    ))}
                                </select>
                                



                            </div>
                            
                        </>
                    )}
                </form>
            </div>

            <div className="enshrine-add-container">                     
                <label style={{ color: "gray", fontSize: "0.9em", display: "block" }}>
                    기본정보를 입력해주세요.
                </label>
                {/* 공백 추가 */}
                <div style={{ margin: "30px 0" }}></div>
                <form onSubmit={handleSubmit} className="form-container">                    
                    <div className="input-group">
                        <label>* 봉안유형</label>
                        <select
                            name="enshrinetype"
                            value={formData.enshrinetype}
                            onChange={handleChange}
                            //defaultValue="" // 기본값으로 아무것도 선택되지 않음
                        >
                            <option value="" disabled>봉안유형을 선택하세요</option>
                            <option value="A">무연고묘 봉안</option>
                            <option value="B">무연고묘 확인(미봉안)</option>
                            <option value="C">연고자 바로봉안</option>
                            <option value="D">연고자묘의 봉안</option>
                            <option value="E">연고자 묘</option>
                        </select>
                    </div>
                    {/* 봉안일자 필드가 봉안유형 값에 따라 조건부로 나타나도록 */}
                    {(formData.enshrinetype === "A" || formData.enshrinetype === "C" || formData.enshrinetype === "D" || formData.enshrinetype === "E") && (
                    <div className="input-group">
                        <label>* 봉안일자</label>
                        <input type="date" name="enshrinedate" value={formData.enshrinedate} onChange={handleChange} />
                    </div>
                    )}
                    {(formData.enshrinetype === "C" || formData.enshrinetype === "D" || formData.enshrinetype === "E") && (
                        <>
                            <div className="input-group">
                                <label>* 고인의 성명</label>
                                <input type="text" name="deceasedname" value={formData.deceasedname} onChange={handleChange} maxLength="18" placeholder="고인의 성명를 입력하세요" />
                            </div>
                            <div className="input-group">
                                <label>출생지</label>
                                <input type="text" name="deceasedbplace" value={formData.deceasedbplace} onChange={handleChange} maxLength="50" placeholder="출생지를 입력하세요" />
                            </div>
                            <div className="input-group">
                                <label>출생일</label>
                                <input type="date" name="deceasedbdate" value={formData.deceasedbdate} onChange={handleChange} />
                            </div>
                            <div className="input-group">
                                <label>사망지</label>
                                <input type="text" name="deceaseddplace" value={formData.deceaseddplace} onChange={handleChange} maxLength="50" placeholder="사망지를 입력하세요" />
                            </div>
                            <div className="input-group">
                                <label>* 사망일</label>
                                <input type="date" name="deceasedddate" value={formData.deceasedddate} onChange={handleChange} />
                            </div>
                            <div className="input-group">
                                <label>유가족ID - (복수 등록가능 / 콤마로 구분)</label>
                                <input type="text" name="bereavedids" value={formData.bereavedids} onChange={handleChange} maxLength="100" placeholder="유가족ID를 입력하세요" />
                            </div>                    
                            <div className="input-group">
                                <label>유가족정보 - (자,자부,사위,손)</label>
                                <textarea name="bereavedinfo" value={formData.bereavedinfo} onChange={handleChange} maxLength="1000" placeholder="유가족들 성명 입력"  />
                            </div>                            
                            <div className="input-group">
                                <label>제사유형선택(종교)</label>
                                <select
                                    name="jesaType"
                                    value={formData.jesaType}
                                    onChange={handleChange}
                                //defaultValue="" // 기본값으로 아무것도 선택되지 않음
                                >
                                    <option value="" disabled>제사유형(종교)을 선택하세요</option>
                                    <option value="1">유교</option>
                                    <option value="2">불교</option>
                                    <option value="3">기독교</option>
                                    <option value="4">천주교</option>                                    
                                </select>
                            </div>
                        </>
                    )}
                    {(formData.enshrinetype !== "") && (
                    <div className="input-group">
                        <label>메모 - (고인을 기리는 마음을 기록해주세요.)</label>
                            <textarea name="deceasedmemo" value={formData.deceasedmemo} onChange={handleChange} maxLength="1000" placeholder="메모 입력"  />
                    </div>
                    )}        
                </form>
            </div>
            
            {(formData.enshrinetype !== "") && (
                <div className="enshrine-add-container">                    
                    <label style={{ color: "gray", fontSize: "0.9em", display: "block" }}>
                        입력된 사진은 업로드 시 1920p(긴쪽)로 자동 리사이즈됩니다. 20Mbyte 미만의 사진을 입력해주세요.<br />
                        묘지사진/봉안사진은 입력된 사진에 GPS정보로 좌표가 확보됩니다. GPS정보가 없는사진은 수동으로 위치를 등록할 수 있습니다.
                    </label>
                    {/* 공백 추가 */}
                    <div style={{ margin: "30px 0" }}></div>
                <form onSubmit={handleSubmit} className="form-container">
                    
                    {(formData.enshrinetype === "A" || formData.enshrinetype === "B" || formData.enshrinetype === "D" || formData.enshrinetype === "E") && (
                    <div className="input-group">
                        <label>* 묘지사진 - (GPS정보 필수등록) (가로사진 권유)</label>
                                <input ref={fileInputRefs.cpictureurl} type="file" name="cpictureurl" accept="image/*"  onChange={handleFileChange}
                                    className={`custom-file-input ${formData.cpictureurl ? 'has-file' : ''}`} />
                                {formData.cpictureurl && (
                                    <div className="image-preview">
                                        <img src={formData.cpictureurl.preview} alt="Preview" />
                                        <button type="button" onClick={() => handleRemoveImage("cpictureurl")}>X</button>
                                    </div>
                                )}

                                
                                {/* 1️⃣ 사진이 있고 좌표가 없으면 주소 검색 UI 표시 */}
                                {formData.cpictureurl && (!formData.cemeterylatitude || !formData.cemeterylongitude) ? (
                                    <div>
                                    <div className="input-group5">
                                            <input type="text" readOnly placeholder="돋보기를 눌러 주소를 지정해주세요." value={formData.address1} style={{ backgroundColor: "#ccffcc" }} />
                                        <button name="location" type="button" className="search-btn5" onClick={() => handleSearchAddress("cpictureurl")}>
                                            <i className="fa fa-search"></i>
                                        </button>                                    
                                        </div>

                                        {/* 위도, 경도 입력 필드 */}
                                        <div className="input-group5">
                                            <input
                                                type="text"
                                                placeholder="위도 입력"
                                                value={latitudeInput}
                                                onChange={(e) => {
                                                    let value = e.target.value.trim(); // 🔹 공백 제거
                                                    value = value.replace(/[^-?\d.]/g, ""); // 🔹 숫자, 소수점, 음수만 유지

                                                    // 🔹 소수점이 여러 개 입력되지 않도록 제한
                                                    const parts = value.split(".");
                                                    if (parts.length > 2) {
                                                        value = parts[0] + "." + parts.slice(1).join("");
                                                    }
                                                    // 🔹 최대 12자리로 제한
                                                    if (value.length <= 12) {
                                                        setLatitudeInput(value);
                                                    }
                                                }}                                                          
                                            />
                                            <input
                                                type="text"
                                                placeholder="경도 입력"
                                                value={longitudeInput}
                                                onChange={(e) => {
                                                    let value = e.target.value.trim(); // 🔹 공백 제거
                                                    value = value.replace(/[^-?\d.]/g, ""); // 🔹 숫자, 소수점, 음수만 유지

                                                    // 🔹 소수점이 여러 개 입력되지 않도록 제한
                                                    const parts = value.split(".");
                                                    if (parts.length > 2) {
                                                        value = parts[0] + "." + parts.slice(1).join("");
                                                    }
                                                    // 🔹 최대 12자리로 제한
                                                    if (value.length <= 12) {
                                                        setLongitudeInput(value);
                                                    }
                                                }}                                                        
                                            />
                                            <button
                                                type="button"
                                                className="search-btn5"
                                                onClick={handleCoordinateSearch} // ✅ 좌표 검색 버튼
                                            >
                                                <i className="fa fa-search"></i>
                                            </button>
                                        </div>

                                    
                                    </div>
                                    
                                ) : (
                                    // 2️⃣ 좌표가 있으면 지도 표시
                                    formData.cemeterylatitude && formData.cemeterylongitude && (
                                        <div className="map-container">
                                            <KakaoMap
                                                latitude={formData.cemeterylatitude}
                                                    longitude={formData.cemeterylongitude}       
                                                    onAddressChange={handleAddressChange1} // ✅ 전달
                                            />
                                        </div>
                                        
                                    )
                                )}


                    </div>
                    )}
                    {(formData.enshrinetype === "A" || formData.enshrinetype === "C" || formData.enshrinetype === "D" ) && (
                    <div className="input-group">
                            <label>봉안사진 - (GPS정보 선택) (가로사진 권유)</label>
                                <input ref={fileInputRefs.epictureurl} type="file" name="epictureurl" accept="image/*" onChange={handleFileChange}
                                    className={`custom-file-input ${formData.epictureurl ? 'has-file' : ''}`} />
                                {formData.epictureurl && (
                                    <div className="image-preview">
                                        <img src={formData.epictureurl.preview} alt="Preview" />
                                        <button type="button" onClick={() => handleRemoveImage("epictureurl")}>X</button>
                                    </div>
                                )}

                                

                                {/* 1️⃣ 사진이 있고 좌표가 없으면 주소 검색 UI 표시 */}
                                {formData.epictureurl && (!formData.enshrinelatitude || !formData.enshrinelongitude) ? (
                                    <div>
                                    <div className="input-group5">
                                            <input type="text" readOnly placeholder="돋보기를 눌러 주소를 지정해주세요." value={formData.address2} style={{ backgroundColor: "#ccffcc" }} />
                                        <button type="button" className="search-btn5" onClick={() => handleSearchAddress("epictureurl")}>
                                            <i className="fa fa-search"></i>
                                        </button>
                                    </div>

                                        {/* 위도, 경도 입력 필드 */}
                                        <div className="input-group5">
                                            <input
                                                type="text"
                                                placeholder="위도 입력"
                                                value={latitudeInput2}
                                                onChange={(e) => {
                                                    let value = e.target.value.trim(); // 🔹 공백 제거
                                                    value = value.replace(/[^-?\d.]/g, ""); // 🔹 숫자, 소수점, 음수만 유지

                                                    // 🔹 소수점이 여러 개 입력되지 않도록 제한
                                                    const parts = value.split(".");
                                                    if (parts.length > 2) {
                                                        value = parts[0] + "." + parts.slice(1).join("");
                                                    }
                                                    // 🔹 최대 12자리로 제한
                                                    if (value.length <= 12) {
                                                        setLatitudeInput2(value);
                                                    }                                                    
                                                }}                                                
                                            />
                                            <input
                                                type="text"
                                                placeholder="경도 입력"
                                                value={longitudeInput2}
                                                onChange={(e) => {
                                                    let value = e.target.value.trim(); // 🔹 공백 제거
                                                    value = value.replace(/[^-?\d.]/g, ""); // 🔹 숫자, 소수점, 음수만 유지

                                                    // 🔹 소수점이 여러 개 입력되지 않도록 제한
                                                    const parts = value.split(".");
                                                    if (parts.length > 2) {
                                                        value = parts[0] + "." + parts.slice(1).join("");
                                                    }
                                                    // 🔹 최대 12자리로 제한
                                                    if (value.length <= 12) {
                                                        setLongitudeInput2(value);
                                                    }                                                    
                                                }}                                                            
                                            />
                                            <button
                                                type="button"
                                                className="search-btn5"
                                                onClick={handleCoordinateSearch2} // ✅ 좌표 검색 버튼
                                            >
                                                <i className="fa fa-search"></i>
                                            </button>
                                        </div>



                                    </div>
                                ) : (
                                    // 2️⃣ 좌표가 있으면 지도 표시
                                        formData.enshrinelatitude && formData.enshrinelongitude && (
                                        <div className="map-container">
                                            <KakaoMap
                                                    latitude={formData.enshrinelatitude}
                                                    longitude={formData.enshrinelongitude}
                                                    onAddressChange={handleAddressChange2} // ✅ 전달
                                            />
                                        </div>

                                    )
                                )}

                    </div>
                        )}

                        {(formData.enshrinetype === "C" || formData.enshrinetype === "D" || formData.enshrinetype === "E") && (
                            <div className="input-group">
                                <label>영정사진 - (세로사진 사용)</label>
                                <input ref={fileInputRefs.ppictureurl} type="file" name="ppictureurl" accept="image/*" onChange={handleFileChange}
                                    className={`custom-file-input ${formData.ppictureurl ? 'has-file' : ''}`} />
                                {formData.ppictureurl && (
                                    <div className="image-preview">
                                        <img src={formData.ppictureurl.preview} alt="Preview" />
                                        <button type="button" onClick={() => handleRemoveImage("ppictureurl")}>X</button>
                                    </div>
                                )}
                            </div>
                        )}
                </form>
            </div>
            )}
            {(formData.enshrinetype !== "") && (
                <div className="enshrine-add-container">                    
                    <label style={{ color: "gray", fontSize: "0.9em", display: "block" }}>
                        입력된 사진은 업로드 시 1920p(긴쪽)로 자동 리사이즈됩니다. 20Mbyte 미만의 사진을 입력해주세요.<br />
                        가로사진 사용을 권유합니다.
                    </label>
                    {/* 공백 추가 */}
                    <div style={{ margin: "30px 0" }}></div>
                    <form onSubmit={handleSubmit} className="form-container">
                        
                    <div className="input-group">
                        <label>추억사진#01 </label>
                            <input ref={fileInputRefs.mpicture01url} type="file" name="mpicture01url" accept="image/*" onChange={handleFileChange}
                                className={`custom-file-input ${formData.mpicture01url ? 'has-file' : ''}`} />
                            {formData.mpicture01url && (
                                <div className="image-preview">
                                    <img src={formData.mpicture01url.preview} alt="Preview" />
                                    <button type="button" onClick={() => handleRemoveImage("mpicture01url")}>X</button>
                                </div>
                            )}
                    </div>
                    <div className="input-group">
                        <label>추억사진#02</label>
                            <input ref={fileInputRefs.mpicture02url} type="file" name="mpicture02url" accept="image/*" onChange={handleFileChange}
                                className={`custom-file-input ${formData.mpicture02url ? 'has-file' : ''}`} />
                            {formData.mpicture02url && (
                                <div className="image-preview">
                                    <img src={formData.mpicture02url.preview} alt="Preview" />
                                    <button type="button" onClick={() => handleRemoveImage("mpicture02url")}>X</button>
                                </div>
                            )}
                    </div>
                    <div className="input-group">
                        <label>추억사진#03</label>
                            <input ref={fileInputRefs.mpicture03url} type="file" name="mpicture03url" accept="image/*" onChange={handleFileChange}
                                className={`custom-file-input ${formData.mpicture03url ? 'has-file' : ''}`} />
                            {formData.mpicture03url && (
                                <div className="image-preview">
                                    <img src={formData.mpicture03url.preview} alt="Preview" />
                                    <button type="button" onClick={() => handleRemoveImage("mpicture03url")}>X</button>
                                </div>
                            )}
                    </div>
                    <div className="input-group">
                        <label>추억사진#04</label>
                            <input ref={fileInputRefs.mpicture04url} type="file" name="mpicture04url" accept="image/*" onChange={handleFileChange}
                                className={`custom-file-input ${formData.mpicture04url ? 'has-file' : ''}`} />
                            {formData.mpicture04url && (
                                <div className="image-preview">
                                    <img src={formData.mpicture04url.preview} alt="Preview" />
                                    <button type="button" onClick={() => handleRemoveImage("mpicture04url")}>X</button>
                                </div>
                            )}
                    </div>
                    <div className="input-group">
                        <label>추억사진#05</label>
                            <input ref={fileInputRefs.mpicture05url} type="file" name="mpicture05url" accept="image/*" onChange={handleFileChange}
                                className={`custom-file-input ${formData.mpicture05url ? 'has-file' : ''}`} />
                            {formData.mpicture05url && (
                                <div className="image-preview">
                                    <img src={formData.mpicture05url.preview} alt="Preview" />
                                    <button type="button" onClick={() => handleRemoveImage("mpicture05url")}>X</button>
                                </div>
                            )}
                    </div>
                    <div className="input-group">
                        <label>추억사진#06</label>
                            <input ref={fileInputRefs.mpicture06url} type="file" name="mpicture06url" accept="image/*" onChange={handleFileChange}
                                className={`custom-file-input ${formData.mpicture06url ? 'has-file' : ''}`} />
                            {formData.mpicture06url && (
                                <div className="image-preview">
                                    <img src={formData.mpicture06url.preview} alt="Preview" />
                                    <button type="button" onClick={() => handleRemoveImage("mpicture06url")}>X</button>
                                </div>
                            )}
                    </div>
                    <div className="input-group">
                        <label>추억사진#07</label>
                            <input ref={fileInputRefs.mpicture07url} type="file" name="mpicture07url" accept="image/*" onChange={handleFileChange}
                                className={`custom-file-input ${formData.mpicture07url ? 'has-file' : ''}`} />
                            {formData.mpicture07url && (
                                <div className="image-preview">
                                    <img src={formData.mpicture07url.preview} alt="Preview" />
                                    <button type="button" onClick={() => handleRemoveImage("mpicture07url")}>X</button>
                                </div>
                            )}
                    </div>
                    <div className="input-group">
                        <label>추억사진#08</label>
                            <input ref={fileInputRefs.mpicture08url} type="file" name="mpicture08url" accept="image/*" onChange={handleFileChange}
                                className={`custom-file-input ${formData.mpicture08url ? 'has-file' : ''}`} />
                            {formData.mpicture08url && (
                                <div className="image-preview">
                                    <img src={formData.mpicture08url.preview} alt="Preview" />
                                    <button type="button" onClick={() => handleRemoveImage("mpicture08url")}>X</button>
                                </div>
                            )}
                    </div>
                    <div className="input-group">
                        <label>추억사진#09</label>
                            <input ref={fileInputRefs.mpicture09url} type="file" name="mpicture09url" accept="image/*" onChange={handleFileChange}
                                className={`custom-file-input ${formData.mpicture09url ? 'has-file' : ''}`} />
                            {formData.mpicture09url && (
                                <div className="image-preview">
                                    <img src={formData.mpicture09url.preview} alt="Preview" />
                                    <button type="button" onClick={() => handleRemoveImage("mpicture09url")}>X</button>
                                </div>
                            )}
                    </div>
                    <div className="input-group">
                        <label>추억사진#10</label>
                            <input ref={fileInputRefs.mpicture10url} type="file" name="mpicture10url" accept="image/*" onChange={handleFileChange}
                                className={`custom-file-input ${formData.mpicture10url ? 'has-file' : ''}`} />
                            {formData.mpicture10url && (
                                <div className="image-preview">
                                    <img src={formData.mpicture10url.preview} alt="Preview" />
                                    <button type="button" onClick={() => handleRemoveImage("mpicture10url")}>X</button>
                                </div>
                            )}
                    </div>
                </form>
                </div>
            )}
            {(formData.enshrinetype !== "") && (
                <div className="enshrine-add-container">
                    <label style={{ color: "gray", fontSize: "0.9em", display: "block" }}>
                        최대 200Mbyte의 동영상을 지원합니다. 가로로 촬영된 동영상 사용을 권유합니다.
                    </label>
                    {/* 공백 추가 */}
                    <div style={{ margin: "30px 0" }}></div>
                <form onSubmit={handleSubmit} className="form-container">
                    <div className="input-group">
                        <label>추억동영상 - (MP4 지원)</label>
                            <input ref={fileInputRefs.mvideourl} type="file" name="mvideourl" accept="video/*" onChange={handleFileChange}
                                className={`custom-file-input ${formData.mvideourl ? 'has-file' : ''}`} />

                            

                            {formData.mvideourl && (
                                <div className="image-preview">
                                    
                                    <video controls width="100%">
                                        <source src={formData.mvideourl.preview} type={formData.mvideourl.file.type} />
                                        브라우저가 동영상을 지원하지 않습니다.
                                    </video>

                                    <button type="button" onClick={() => handleRemoveImage("mvideourl")}>X</button>

                                </div>
                            )}                            
                    </div>
                </form>
            </div>
            )}
            {isLoading && <LoadingSpinner />}            
            {isLoading && (            
                <progress value={progress} max="100" ></progress>                
            )}
            <button type="submit" className="save-button" onClick={handleSubmit}>봉안등록</button>

            
        </div>

    );
    
};

export default EnshrineAdd;
